import React from "react";
import PartyDetails from "../features/PartyDetail/component/PartyDetails";
import Footer from "./Footer";
// import PartyDetailsTest from "../features/PartyDetail/component/PartyDetailsTest";

function PartyDetailsPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <PartyDetails></PartyDetails>
      {/* <PartyDetailsTest></PartyDetailsTest> */}
      <Footer />
    </div>
  );
}

export default PartyDetailsPage;
